export enum SmartNudgeStatusEnum {
  Pending = 'pending',
  Sent = 'sent',
  Dismissed = 'dismissed',
  Booked = 'booked',
}

export enum SmartNudgeChannelEnum {
  SMS = 'sms',
  WhatsApp = 'whatsapp',
}

export interface ISmartNudgeSuggestion {
  id?: string;
  bid: string;
  customerId: string;
  customerName: string;
  customerPhone: string;
  /** The service(s) the customer typically books */
  serviceIds: string[];
  serviceNames: string[];
  /** Predicted visit cycle in days (e.g., 21 for "every 3 weeks") */
  visitCycleDays: number;
  /** Date of the customer's last visit for these services */
  lastVisitDate: Date | string;
  /** Total completed visits in the history lookback window (≈1 year) */
  totalVisits: number;
  /** Predicted next visit date */
  predictedNextVisitDate: Date | string;
  /** Days overdue (negative = not yet due) */
  daysOverdue: number;
  /** Available slot suggestions */
  suggestedSlots: ISmartNudgeSlot[];
  /** Auto-generated personalized message */
  message: string;
  /** Whether customer is in loyalty program */
  isInLoyaltyProgram: boolean;
  /** Current status */
  status: SmartNudgeStatusEnum;
  /** Which channel was used to send */
  sentVia?: SmartNudgeChannelEnum;
  sentAt?: Date | string;
  /** Date this suggestion was generated */
  createdAt: Date | string;
}

export interface ISmartNudgeSlot {
  date: string;
  hour: number;
  providingClient: string;
}

export interface ISmartNudgeDailySummary {
  bid: string;
  date: string;
  suggestions: ISmartNudgeSuggestion[];
  totalDueThisWeek: number;
}

export interface ISmartNudgeSendRequest {
  suggestionId: string;
  channel: SmartNudgeChannelEnum;
  customMessage?: string;
}
